import { render } from "./InputValorBRL.vue?vue&type=template&id=5b7b413b"
import script from "./InputValorBRL.vue?vue&type=script&lang=js"
export * from "./InputValorBRL.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__